import React from 'react';
import {TablePagination} from '@mui/material';
import {
  TablePaginationWrapper,
  RowsCountDivStyle,
  PaginationStyle
} from '../../../../sub-modules-menu/collapsible-table/CollapsibleTableStyle';

const TablePaginationRows = (props: any) => {
  const handleChangePage = (event: any, newPage: number) => {
    props.setPage(newPage);
  };
  const handleChangePageSize = (event: any) => {
    props.setPageSizes(parseInt(event.target.value, 10));
  };
  return (
    <TablePaginationWrapper>
      <TablePagination
        className="pagination-container"
        component="div"
        count={props?.totalRecordsCount}
        page={props.page}
        onPageChange={handleChangePage}
        rowsPerPage={props.pageSize}
        onRowsPerPageChange={handleChangePageSize}
        rowsPerPageOptions={props.rowsPerPageOptions}
      />
    </TablePaginationWrapper>
  );
};

const CustomPagination = (props: any): React.ReactElement => {
  return (
    <>
      {!props.hideRowCount ? (
        <RowsCountDivStyle>
          {`Total Rows: ${props.totalRows || 0}`}
        </RowsCountDivStyle>
      ) : null}
      <TablePaginationRows {...props} />
      <PaginationStyle
        className="pp"
        color="primary"
        count={props?.pageCount}
        page={props?.page}
        showFirstButton
        showLastButton
        onChange={(event: any, value: any) => props.setPage(value)}
        siblingCount={2}
        boundaryCount={2}
      />
    </>
  );
};

export default CustomPagination;
